import React from 'react';
interface CTASectionProps {
  onOpenDemo: () => void;
}
export function CTASection({
  onOpenDemo
}: CTASectionProps) {
  return <section className="bg-accent-red py-24 md:py-32" data-id="element-80">
      <div className="max-w-4xl mx-auto px-6 text-center space-y-12" data-id="element-81">
        <h2 className="text-stark-white text-4xl md:text-6xl font-manrope font-bold leading-tight uppercase" data-id="element-82">
          Ready to See What Your Numbers Are Really Saying?
        </h2>
        <p className="text-stark-white/90 text-xl md:text-2xl font-inter max-w-2xl mx-auto" data-id="element-83">
          Book a quick walkthrough and see how ROI can help you better
          understand your restaurant operations.
        </p>
        <div className="pt-8" data-id="element-84">
          <button onClick={onOpenDemo} className="bg-stark-white text-accent-red px-12 py-6 rounded-full text-xl font-extrabold hover:scale-105 transition-all shadow-2xl shadow-black/20" data-id="element-85">
            Book Your Demo
          </button>
        </div>
      </div>
    </section>;
}